/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const DottedLine = styled.div<{ color: string }>`
  background-image: linear-gradient(
    to right,
    ${({ color }) => color} 70%,
    transparent 0%
  );
  background-position: bottom;
  background-size: 8px 2px;
  background-repeat: repeat-x;
  width: ${theme.spacing.spacing08};
  height: 2px;
  margin-right: ${theme.spacing.spacing02};
  margin-left: ${theme.spacing.spacing04};
`;
